export const THREAD_INBOX_UPDATED = 'THREAD_INBOX_UPDATED';